<template>
  <div>
    <div v-if="SuchbegriffGross">
      <span
        class="title text-truncate"
        v-if="this.$store.getters.fetchSuchbegriff"
      >
        <v-icon>keyboard_arrow_right</v-icon>
        {{ SuchbegriffGross }} in {{ StadtNameGross }} {{ PLZ }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  metaInfo () {
    return { title: this.SuchbegriffGross + ' in ' + this.StadtNameGross }
  },

  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters({
      fetchBetriebe: 'fetchBetriebe'
    }),
    StadtNameGross: function () {
      return this.$store.state.suche.stadt
    },
    PLZ: function () {
      return this.$store.state.suche.plz
    },
    SuchbegriffGross: function () {
      if (this.$store.state.suche.suchbegriffmanuell) {
        return this.$store.state.suche.suchbegriffmanuell
      }
      if (
        typeof this.$store.getters.fetchBetriebe.suchbegriff.leistung ===
        'object'
      ) {
        return (
          'Thema: ' + this.$store.getters.fetchBetriebe.suchbegriff.suchbegriff
        )
      }

      if (this.$store.getters.fetchBetriebe.suchbegriff.leistung) {
        return this.$store.getters.fetchBetriebe.suchbegriff.leistung
      } else {
        return ''
      }
      // return this.$store.getters.fetchBetriebe.suchbegriffmanuell
    }
  },
  mounted: function () {},

  methods: {}
}
</script>
<style>
</style>